import Vue from 'vue';
import App from './App';
import Impedimento from './Impedimento';
import Estadisticas from './pages/estadisticas/Index';
import vuetify from './plugins/vuetify';
import archivos from '@demre/client-common/src/plugins/archivos';
import router from './router';
import store from './store';
import graphql from './utils/graphql';
import validator from './utils/validator';

Vue.use(archivos);
Vue.config.productionTip = false;
Vue.use(validator);

async function init() {
  const { getUsername: username } = store.getters;
  const query = {
    query: `query ($username: String!) {
      usuario: usuario(username: $username) {
        rol {
          idRol
          nombre
        }
      }
      ued: unidadEducativa {
        rbd
        codEns
        uedNombre
        ramaEducacional {
          nombre
        }
        comuna {
          comNombre
        }
      }
      modulos
      config {
        anioProcesoAdmision
        fspCodigo
      }
      proceso: getProcesoVigente {
        secuencia
        nombre
        anioPromocion
      }
    }`,
    variables: {
      username,
    }
  };
  const { usuario, ued, modulos, config, proceso } = await graphql.request(query);
  usuario.rbd = ued.rbd;
  usuario.codEns = ued.codEns;
  usuario.ued = `${ued.rbd}-${ued.codEns} ${ued.uedNombre} ::: ${ued.ramaEducacional.nombre} ::: ${ued.comuna.comNombre}`;
  store.commit('setUsuario', usuario);
  store.commit('setModulos', modulos);
  store.commit('setAnioProcesoAdmision', config.anioProcesoAdmision);
  store.commit('setFspCodigo', config.fspCodigo);
  store.commit('setProceso', proceso);
  window.DATA = {};
  window.DATA.profileUrl = `${process.env.VUE_APP_CADES_CLIENT}/profile?appId=${process.env.VUE_APP_CADES_ID}&username=${username}`;
  window.DATA.urlManual = process.env.VUE_APP_URL_MANUAL || '';
}

if (window.location.pathname === '/estadistica-resultados-puntajes') {
  new Vue({
    vuetify,
    router,
    store,
    render: h => h(Estadisticas)
  }).$mount('#app');

} else {
  store
  .dispatch('session/load')
  .then(init)
  .then(() => {
    new Vue({
      vuetify,
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  })
  .catch(async (err) => {
    const mensaje = err.message;
    new Vue({
      vuetify,
      router,
      store,
      render: h => h(Impedimento, { props: { mensaje } })
    }).$mount('#app');
  });
}

window.store = store;

